import { motion } from 'motion/react'
import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useLanguage } from '@/i18n/LanguageContext'

const CHIPS = ['Food tour', 'The Voyage', 'The Village', 'Real Wanderlust', 'Aurea Viaggi', 'WeRoad']

export default function CollaborationsSection() {
  const { t } = useLanguage()
  const copy = t.collaborations

  return (
    <section id="collaborazioni" className="relative overflow-hidden bg-[#F5EADF] py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
          className="text-center"
        >
          <p className="mb-4 text-sm font-medium uppercase tracking-[0.25em] text-terracotta">
            {copy.homeEyebrow}
          </p>
          <h2 className="font-display text-4xl leading-tight text-ink md:text-5xl">
            {copy.homeTitleBefore}{' '}
            <span className="italic text-terracotta">{copy.homeTitleAccent}</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink/70">
            {copy.homeText}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-10 flex flex-wrap items-center justify-center gap-3"
        >
          {CHIPS.map((chip) => (
            <span
              key={chip}
              className="rounded-full border border-ink/15 bg-white/60 px-4 py-2 text-sm font-medium text-ink/70"
            >
              {chip}
            </span>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="mt-12 text-center"
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            transition={{ type: 'spring', stiffness: 400, damping: 20 }}
            className="inline-block"
          >
            <Link
              to="/collaborazioni#top"
              className="inline-flex items-center gap-3 whitespace-nowrap rounded-full bg-terracotta px-7 py-4 font-semibold text-cream shadow-lg shadow-terracotta/30"
              onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
            >
              {copy.homeCta}
              <ArrowRight className="h-5 w-5" />
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}
